import axiosInstance from "./AxiosInstance";

// Get disease history by patient ID
export const getDiseaseHistory = async (patient_id) => {
  return axiosInstance.post("/admin/DiseaseHistory", { patient_id });
};

// Format disease history records
export function formatDiseaseHistory(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((entry) => ({
      ...entry,
      id:
        entry.patient_disease_history_id ||
        entry.id ||
        entry._id ||
        Math.random().toString(36),
    }));
  }

  const diseases = [];
  for (let key in responseData) {
    if (Object.prototype.hasOwnProperty.call(responseData, key)) {
      const entry = responseData[key];
      diseases.push({
        ...entry,
        id:
          entry.patient_disease_history_id ||
          entry.id ||
          entry._id ||
          key,
      });
    }
  }

  return diseases;
}
